import * as React from 'react';

import { IGlob } from '../../../_common/application/ts/Glob';
import { IParameterFieldBaseOptions } from '../../platform/ts/ParameterFieldBase';

import {
    SuggestionSelect,
    ISuggestionValue,
    convertToSuggestionValues
} from '../../../_common/platform/tsx/SuggestionSelect';

export interface ISelectMultiFieldOptions extends IParameterFieldBaseOptions {
    values?: string[];
    getModifiedValues?: (values: any[]) => any;
}

export default class SelectMultiField extends React.Component<
    {
        value?: string[];
        options?: ISelectMultiFieldOptions;
        values?: string[];
        glob: IGlob;

        onChange?(value: string[]): void;
    },
    {
        value?: string[];
    }
> {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value ?? []
        };
    }

    handleEntityModelsStoreChange = () => {
        this.setState(this.state);
    };

    componentDidMount() {
        this.props.glob.EntityModelsStore.addChangeListener(this.handleEntityModelsStoreChange);
    }

    componentWillUnmount() {
        this.props.glob.EntityModelsStore.removeChangeListener(this.handleEntityModelsStoreChange);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }

    handleOnChange = (values: ISuggestionValue[]) => {
        const result = values.map((value) => {
            return value.value;
        });

        this.setState({ value: result });

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(result);
        }
    };

    render() {
        const { options } = this.props;

        let value = this.state.value;
        let items = options?.values ?? [];

        //LL: like in SelectExtendedField
        let mvd = null;

        if (options != null && typeof options.getModifiedValues === 'function') {
            mvd = options.getModifiedValues(this.props.values);
        }

        if (mvd != null) {
            items = mvd.values;
        }

        //LL: rem unwanted values, modified "items" may be less than saved "value"
        //   "value" is array of selected
        value = value.filter((item) => items.includes(item));

        const displayValues = convertToSuggestionValues(items);

        return (
            <div className={'selectmulti-field'}>
                <SuggestionSelect
                    value={value}
                    displayValues={displayValues}
                    singleSelectMode={false}
                    hideSearchField={true}
                    allowReordering={true}
                    allowNull={false}
                    listThreshold={10}
                    keySelect={true}
                    theme={this.props.options?.theme}
                    glob={this.props.glob}
                    onChange={this.handleOnChange}
                />
            </div>
        );
    }
}
